import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";

const BrandDisplay = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(true);
  }, []);
  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.8s",
        position: "absolute",
        top: 0,
        backgroundColor: open ? colors.white : colors.primaryPink,
      }}
    >
      Brand Display
    </div>
  );
};

export default BrandDisplay;
